import { useState } from 'react';
import './DRResourceCard.css';
import SideBoltIcon from '../../../assets/icons/side-bolt.svg?react';
import ChevronDownIcon from '../../../assets/icons/chevron-down.svg?react';
const DRResourceCard = ({ resource, onResourceClick }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = (e) => {
    e.stopPropagation(); // 부모 클릭 이벤트 방지
    setIsExpanded(!isExpanded);
  };

  const handleCardClick = () => {
    onResourceClick(resource);
  };

  return (
    <div 
      className={`dr-resource-card ${isExpanded ? 'expanded' : 'collapsed'}`}
      onClick={handleCardClick}
    >
      <div className="dr-resource-header">
        <div className="dr-resource-header-left">
          <div className="dr-resource-icon">
            <SideBoltIcon color='var(--primary-600)'/>
          </div>
          <div className="dr-resource-title">
            {resource.ResourceName}
          </div>
        </div>
        <button 
          className="dr-resource-toggle cursor-pointer"
          onClick={handleToggle}
        >
          <ChevronDownIcon color='var(--gray-600)' className={`toggle-icon ${isExpanded ? 'expanded' : ''}`}/>
        </button>
      </div>
      
      {isExpanded && (
        <div className="dr-resource-content">
          <div className="dr-resource-info-row">
            <span className="dr-resource-label">주소</span>
            <span className="dr-resource-value">
              {resource.RegionSido} {resource.RegionSigungu} {resource.RegionEupMyuonDong}
            </span>
          </div>
          <div className="dr-resource-info-row divide">
            <div className="flex align-center">
              <span className="dr-resource-label">충전소 수</span>
              <span className="dr-resource-value station-count">
                {resource.Stations?.length || 0}
              </span>
            </div>
            <div className="flex align-center">
              <span className="dr-resource-label">충전기 수</span>
              <span className="dr-resource-value charger-count">
                {resource.Chargers?.length || 0}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DRResourceCard;
